/**
 * Super-admin users per environment.
 * The environment is derived from the API base URL (VITE_ADNUNTIUS_API_BASE).
 */

const API_BASE = import.meta.env.VITE_ADNUNTIUS_API_BASE || 'https://api.dev.adnuntius.com/api'

const SUPER_ADMINS: Record<string, string[]> = {
  dev: ['broker1@adnuntius.com'],
  staging: ['broker1@adnuntius.com'],
  prod: ['adnuntius@adnuntius.com'],
}

function detectEnv(): string {
  if (API_BASE.includes('api.adnuntius.com') && !API_BASE.includes('dev') && !API_BASE.includes('staging')) return 'prod'
  if (API_BASE.includes('staging')) return 'staging'
  return 'dev'
}

const env = detectEnv()

export function isSuperAdmin(username: string | undefined): boolean {
  if (!username) return false
  return (SUPER_ADMINS[env] ?? []).includes(username.toLowerCase())
}
